import { Box } from "@mui/material";
import { Checkbox, Typography } from "@platform/design-system";

export const HasIssuesCheckbox = (): React.JSX.Element => (
  <Box component="label" display="flex" alignItems="center">
    <Checkbox />
    <Typography variant="body-medium" component="span">
      Has issues
    </Typography>
  </Box>
);
